import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { closePublishSheet } from '@/redux/slices/publishSheetSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { TrueSheet } from '@lodev09/react-native-true-sheet'
import { useEffect, useRef } from 'react'
import { Text, View } from 'react-native'
import FormPublish from './FormPublish'

export default function FormPublishSheet() {
  const dispatch = useAppDispatch()
  const sheetRef = useRef<TrueSheet>(null)
  const { open, formToken } = useAppSelector(state => state.publishSheet)
  const [backgroundColor] = usePlatformColor('systemGroupedBackgroundColor')

  useEffect(() => {
    if (open) {
      sheetRef.current?.present().catch(() => {})
    } else {
      sheetRef.current?.dismiss().catch(() => {})
    }
  }, [open])

  const handleDismiss = () => {
    dispatch(closePublishSheet())
  }

  return (
    <TrueSheet
      ref={sheetRef}
      name="publish-sheet"
      detents={['auto']}
      grabber
      backgroundColor={backgroundColor}
      onDidDismiss={handleDismiss}
    >
      <View style={{ padding: 16 }}>
        {/* Magic fix: https://qunli.co/2025/projects/115/tasks/10485 */}
        <Text />
        {formToken && <FormPublish formToken={formToken} />}
      </View>
    </TrueSheet>
  )
}
